import React from 'react';
import ReactDOM from 'react-dom';
import './resources/scss/main.scss';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';
import {Provider} from "mobx-react"
import CheckInStore from "./stores/CheckInStore"
import UserStore from "./stores/UserStore"
import RiderStore from "./stores/RiderStore"
import HeaderStore from "./stores/HeaderStore"


const stores = {
  CheckInStore,
  UserStore,
  RiderStore,
  HeaderStore
};

ReactDOM.render(<Provider {...stores}><App /></Provider>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js